import { INTERNAL_SERVER_URL } from "@constants/api";
import { authInstance } from "@utils/firebase";

export async function updatePlan(planId: string) {
  const idToken = await authInstance.currentUser?.getIdToken();

  const response = await fetch(`${INTERNAL_SERVER_URL}/paddle/update-plan`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify({
      plan_id: planId
    }),
  });
  const result = await response.json();
  if (response.ok) {
    return result;
  } else {
    throw new Error(result.error);
  }
}